<script>
import { Bar } from 'vue-chartjs'
export default {
  extends: Bar,
  props: ['data', 'options', 'weather'],
  mounted () {
    this.addPlugin({
      afterDraw: (chart) => {
        const ctx = chart.ctx
        const xAxis = chart.scales['x-axis-0']
        const yAxis = chart.scales['y-axis-0']

        xAxis.ticks.forEach((value, index) => {
          if (this.weather && this.weather[index].upr_clima_icon) {
            const x = xAxis.getPixelForValue(value)
            const image = new Image()
            image.src = `https://openweathermap.org/img/wn/${this.weather[index].upr_clima_icon}.png`
            ctx.drawImage(image, x - 25, yAxis.bottom - 25)
          }
        })
      }
    })
    this.renderChart(this.data, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/graficos/BarChart.vue